import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/boxed-logo.png';
import '../../styles/Navbar.css';

function userInitials(username) {
  if (!username) return '?';
  const parts = String(username).trim().split(/[\s._-]+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return String(username).slice(0, 2).toUpperCase();
}

function roleLabel(role) {
  const labels = {
    admin: 'Administrator',
    manager: 'Manager',
    user: 'User',
  };
  return labels[role] || role;
}

const Navbar = ({ user, onLogout }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    onLogout();
    navigate('/');
  };

  return (
    <header className="navbar">
      <div className="navbar-brand">
        <img src={logo} alt="Boxed" className="navbar-logo" />
        <div className="navbar-brand-text">
          <span className="navbar-app-name">Boxed</span>
          <span className="navbar-tagline">Provision Global Solutions</span>
        </div>
      </div>

      <div className="navbar-actions">
        <div className="navbar-user-card" title={`Signed in as ${user.username}`}>
          <div className="navbar-avatar" aria-hidden="true">
            {userInitials(user.username)}
          </div>
          <div className="navbar-user-meta">
            <span className="navbar-username">{user.username}</span>
            <span className={`navbar-role-badge role-${user.role || 'user'}`}>
              {roleLabel(user.role)}
            </span>
          </div>
        </div>

        <div className="navbar-divider" aria-hidden="true" />

        <button type="button" className="btn-logout" onClick={handleLogout}>
          <svg
            className="btn-logout-icon"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
          <span>Sign out</span>
        </button>
      </div>
    </header>
  );
};

export default Navbar;
